import { AutoComplete, Button, Col, Divider, Form, Input, Row, Select } from 'antd';
import moment from 'moment';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { useAuth } from '../../../../../context/AuthProvider';
import { updateField, updatePmOfferInterval } from '../../../../../contextRedux/PMOffer/PmOfferModel';
import { RootState } from '../../../../../store';

const CompanyDetailsTab: React.FC<any> = ({ form }) => {
  const useQueryHook = () => new URLSearchParams(useLocation().search);
  const dispatch = useDispatch();
  //initialize from pmOffer

  const query = useQueryHook();
  const companyIdFromRoute = query.get('companyId');
  const id = useSelector((state: RootState) => state?.models?.pmOffer?.id);
  const companyId = useSelector((state: RootState) => state?.models?.pmOffer?.companyId);

  //initialize from parrent NewOffer
  const companies = useSelector((state: RootState) => state.store.company.data);
  const pmOfferStatuses = useSelector((state: RootState) => state?.store.pmOfferStatus.data);
  const pmOfferContractTypes = useSelector((state: RootState) => state?.store.pmOfferContractType.data);
  const accountSales = useSelector((state: RootState) => state?.store.user.data);
  const pmOffer = useSelector((state: RootState) => state?.models.pmOffer);

  const [currentTotal, setCurrentTotal] = useState(0);
  const currentDate = moment().format('YYYY-MM-DD');
  const { profile } = useAuth();

  const initialValues = {
    company: useSelector((state: RootState) => state?.models?.pmOffer?.company),
    companyId: useSelector((state: RootState) => state?.models?.pmOffer?.companyId),
    accountManager: useSelector((state: RootState) => state?.models?.pmOffer?.accountManager),
    accountManagerId: useSelector((state: RootState) => state?.models?.pmOffer?.accountManagerId),
    accountSale: useSelector((state: RootState) => state?.models?.pmOffer?.accountSale),
    accountSaleId: useSelector((state: RootState) => state?.models?.pmOffer?.accountSaleId),
    enumPmOfferContractTypeId: useSelector((state: RootState) => state?.models?.pmOffer?.enumPmOfferContractTypeId),
    enumPmOfferContractType: useSelector((state: RootState) => state?.models?.pmOffer?.enumPmOfferContractType),
    enumPmOfferStatusId: useSelector((state: RootState) => state?.models?.pmOffer?.enumPmOfferStatusId),
    enumPmOfferStatus: useSelector((state: RootState) => state?.models?.pmOffer?.enumPmOfferStatus),
    date: useSelector((state: RootState) => state?.models?.pmOffer?.date),
    dateStart: useSelector((state: RootState) => state?.models?.pmOffer?.dateStart),
    dateEnd: useSelector((state: RootState) => state?.models?.pmOffer?.dateEnd),
    remarks: useSelector((state: RootState) => state?.models?.pmOffer?.remarks),
    pmOfferIntervals: useSelector((state: RootState) => state?.models?.pmOffer?.pmOfferIntervals),
    totalOfferValue:
      Number.parseFloat(
        (
          pmOffer.pmOfferWorkPlaceItems.reduce((total, item) => total + item.laborPrice, 0) +
          (pmOffer.pmOfferLaborExtras
            ? pmOffer.pmOfferLaborExtras.reduce((total: any, item: any) => total + item?.piece * item?.price, 0)
            : 0)
        ).toFixed(2)
      ) +
      Number.parseFloat(
        pmOffer.pmOfferWorkPlaceItems.reduce((total, item) => {
          const totalPrice = item.price;
          return total + totalPrice;
        }, 0)
      ),
  };

  useEffect(() => {
    if (!!companyIdFromRoute && companies?.length > 0) {
      const selectedCompany = companies.find((c: any) => c?.id == companyIdFromRoute);
      const fieldsValue = {
        ...form.getFieldsValue(true),
        company: { name: selectedCompany?.name, ...selectedCompany },
        companyId: selectedCompany?.id,
        accountManager: selectedCompany?.accountManager,
      };

      dispatch(updateField({ field: 'companyId', value: selectedCompany?.id ?? null }));
      dispatch(updateField({ field: 'company', value: selectedCompany ?? null }));

      dispatch(updateField({ field: 'accountManagerId', value: selectedCompany?.accountManager?.id ?? null }));
      dispatch(updateField({ field: 'accountManager', value: selectedCompany?.accountManager ?? null }));

      form.setFieldsValue(fieldsValue);
    }
  }, [companyIdFromRoute]);

  const handleFieldChange = (changedValues: any, allValues: any) => {
    for (const key in changedValues) {
      if (key === 'pmOfferIntervals') {
        // Recalculate total
        calculateTotal(allValues['pmOfferIntervals']);
        // Update the entire intervals array in Redux state
        dispatch(updateField({ field: 'pmOfferIntervals', value: allValues['pmOfferIntervals'] }));
      } else {
        dispatch(updateField({ field: key, value: changedValues[key] }));
      }
    }
  };

  const handleSelectClient = (value: any) => {
    const company = companies.find((company: any) => company.name === value?.label);

    const fieldsValue = {
      ...form.getFieldsValue(true),
      company: { ...company },
      companyId: company?.id,
      accountManager: company?.accountManager,
    };

    form.setFieldsValue(fieldsValue);

    dispatch(updateField({ field: 'companyId', value: company?.id ?? null }));
    dispatch(updateField({ field: 'company', value: company ?? null }));

    dispatch(updateField({ field: 'accountManagerId', value: company?.accountManager?.id ?? null }));
    dispatch(updateField({ field: 'accountManager', value: company?.accountManager ?? null }));
  };

  const handleSelectAccountSales = (value: string) => {
    const accountSale = accountSales?.find((date: any) => date.name === value);

    const fieldsValue = {
      ...form.getFieldsValue(true),
      accountSale: accountSale,
      accountSaleId: accountSale?.id,
    };

    form.setFieldsValue(fieldsValue);
    dispatch(updateField({ field: 'accountSaleId', value: accountSale?.id ?? null }));
    dispatch(updateField({ field: 'accountSale', value: accountSale ?? null }));
  };

  const handleSelectStatus = (value: string) => {
    const selectStatus = pmOfferStatuses.find((date) => date.name === value);

    const fieldsValue = {
      ...form.getFieldsValue(true),
      enumPmOfferStatusId: selectStatus?.id,
      enumPmOfferStatus: selectStatus,
    };
    form.setFieldsValue(fieldsValue);
    dispatch(updateField({ field: 'enumPmOfferStatusId', value: selectStatus?.id ?? null }));
    dispatch(updateField({ field: 'enumPmOfferStatus', value: selectStatus ?? null }));
  };

  const handleSelectType = (value: string) => {
    const selectedType = pmOfferContractTypes
      .filter((pc) => [1, 3].includes(pc.id))
      .find((type) => type.name === value);

    const fieldsValue = {
      ...form.getFieldsValue(true),
      enumPmOfferContractTypeId: selectedType?.id,
      enumPmOfferContractType: selectedType,
    };
    form.setFieldsValue(fieldsValue);
    dispatch(updateField({ field: 'enumPmOfferContractTypeId', value: selectedType?.id ?? null }));
    dispatch(updateField({ field: 'enumPmOfferContractType', value: selectedType ?? null }));
  };

  const onDateChange = (dateField: string, dateValue: string) => {
    dispatch(updateField({ field: dateField, value: dateValue }));
    form.setFieldsValue({ [dateField]: dateValue });
  };

  const handleBlurClear = (fieldNames: string[]) => {
    fieldNames.forEach((field) => {
      form.setFieldsValue({ [field]: null });
      dispatch(updateField({ field, value: null }));
    });
  };

  // Access interval price based on the current index
  const getCurrentIntervalPrice = () => {
    const total = form
      .getFieldValue('pmOfferIntervals')
      .reduce((acc: number, cur: any) => acc + Number(cur?.price ?? 0), 0);
    return total ?? 0;
  };

  const handleRemove = (remove: Function, name: number) => {
    remove(name);
    const intervals = [...(form.getFieldValue('pmOfferIntervals') || [])];
    intervals.splice(name, 1); // Remove the interval from the array
    calculateTotal(intervals);
  };

  const calculateTotal = (intervals: any[]) => {
    const total = (intervals || []).reduce((sum, interval) => sum + Number(interval?.price || 0), 0);
    setCurrentTotal(total);
  };

  const handleAddInterval = (add: Function) => {
    add();
  };

  useEffect(() => {
    form.setFieldValue('pmOfferIntervals', pmOffer.pmOfferIntervals);
  }, []);

  useEffect(() => {
    if (companyId) {
      const company = companies.find((company: any) => company.id === companyId);
      form.setFieldsValue({
        company: { name: company?.name },
        companyId: company?.id,
        accountManager: company?.accountManager,
      });
      dispatch(updateField({ field: 'companyId', value: company?.id ?? null }));
      dispatch(updateField({ field: 'company', value: company ?? null }));
      form.setFieldsValue({
        ...initialValues,
      });
      if (id == null || id == undefined || id == '') {
        handleSelectAccountSales(profile?.name!);
      }
    }
  }, [companyId]);

  useEffect(() => {
    if (id == null || id == undefined || id == '') {
      const currentDate = new Date().toISOString().split('T')[0];
      const oneYearLater = new Date();
      oneYearLater.setFullYear(oneYearLater.getFullYear() + 1);
      const formattedOneYearLater = oneYearLater.toISOString().split('T')[0];

      form.setFieldsValue({
        enumPmOfferStatus: { id: 1, name: 'Lead' },
        enumPmOfferStatusId: 1,
        enumPmOfferContractType: { id: 3, name: 'Instalare' },
        enumPmOfferContractTypeId: 2,
        date: currentDate,
        dateStart: currentDate,
        dateEnd: formattedOneYearLater,
      });

      dispatch(updateField({ field: 'enumPmOfferStatusId', value: 1 }));
      dispatch(updateField({ field: 'enumPmOfferStatus', value: { id: 1, name: 'Lead' } }));
      dispatch(updateField({ field: 'enumPmOfferContractTypeId', value: 3 }));
      dispatch(updateField({ field: 'enumPmOfferContractType', value: { id: 3, name: 'Instalare' } }));
      dispatch(updateField({ field: 'date', value: currentDate }));
      dispatch(updateField({ field: 'dateStart', value: currentDate }));
      dispatch(updateField({ field: 'dateEnd', value: formattedOneYearLater }));
    }
  }, [id]);

  const isLastStatusSelected =
    pmOfferStatuses && pmOffer.enumPmOfferStatus?.name === pmOfferStatuses[pmOfferStatuses.length - 1]?.name;
  const remainingValue = initialValues.totalOfferValue - currentTotal;

  return (
    <Form
      form={form}
      initialValues={initialValues}
      onValuesChange={handleFieldChange}
      layout='vertical'
      style={{ margin: '20px 20px' }}
    >
      <Row gutter={[10, 10]}>
        <Col xs={24} sm={12} md={12} lg={8}>
          <Form.Item
            name={['company', 'name']}
            label='Selectati Client'
            rules={[{ required: true, message: 'Alegeti un client!' }]}
          >
            <Select
              disabled={!!id}
              showSearch // Enables search functionality
              placeholder='Search and select a client'
              optionFilterProp='label'
              onSelect={(_value, option: any) => {
                handleSelectClient(option);
              }}
              onChange={() => handleBlurClear(['company', 'companyId'])} // Clear form fields when changed
              filterOption={(input, option) => {
                return option?.label?.toLowerCase()?.includes(input.toLowerCase());
              }}
              options={companies?.map((company) => ({
                value: company?.id,
                label: company?.name,
              }))}
            />
          </Form.Item>
        </Col>
        <Col xs={24} sm={12} md={12} lg={8}>
          <Form.Item
            name={['accountManager', 'name']}
            label='Manager de cont'
            rules={[{ required: true, message: 'Alegeti un manager de cont!' }]}
          >
            <Input disabled={true} />
          </Form.Item>
        </Col>
        <Col xs={24} sm={12} md={12} lg={8}>
          <Form.Item
            name={['accountSale', 'name']}
            label='Agent Vanzari'
            rules={[{ required: true, message: 'Alegeti un agent de vanzari!' }]}
          >
            <AutoComplete
              options={accountSales?.map((item: any) => ({ value: item?.name }))}
              onSelect={handleSelectAccountSales}
              onChange={() => handleBlurClear(['accountSale', 'accountSaleId'])}
              filterOption={(input, option: any) => option.value.toLowerCase().includes(input.toLowerCase())}
            />
          </Form.Item>
        </Col>
        <Col xs={24} sm={12} md={12} lg={8}>
          <Form.Item
            name={['enumPmOfferStatus', 'name']}
            label='Status'
            rules={[{ required: true, message: 'Alegeti un status!' }]}
          >
            <AutoComplete
              options={pmOfferStatuses?.map((item: any) => ({ value: item?.name }))}
              onSelect={handleSelectStatus}
              onChange={() => handleBlurClear(['enumPmOfferStatus', 'enumPmOfferStatusId'])}
            />
          </Form.Item>
        </Col>
        <Col xs={24} sm={12} md={12} lg={8}>
          <Form.Item
            name={['enumPmOfferContractType', 'name']}
            label='Tip oferta'
            rules={[{ required: true, message: 'Alegeti un tip oferta!' }]}
          >
            <AutoComplete
              options={pmOfferContractTypes
                ?.filter((pc) => [1, 3].includes(pc.id))
                ?.map((item: any) => ({ value: item?.name }))}
              onSelect={handleSelectType}
              onChange={() => handleBlurClear(['enumPmOfferContractType', 'enumPmOfferContractTypeId'])}
            />
          </Form.Item>
        </Col>
        <Divider />
      </Row>

      <Row gutter={[16, 1]}>
        <Col xs={24} sm={12} md={12} lg={8}>
          <Form.Item label='Data Oferta' name='date' rules={[{ required: true, message: 'Introduceti data oferta!' }]}>
            <Input type='date' onChange={(e) => onDateChange('date', e.target.value)} min={currentDate} />
          </Form.Item>
        </Col>
        {isLastStatusSelected && (
          <>
            <Col xs={24} sm={12} md={12} lg={8}>
              <Form.Item
                label='Data Incepere Proiect'
                name='dateStart'
                rules={[
                  {
                    required: true,
                    message: 'Introduceti data incepere proiect!',
                  },
                ]}
              >
                <Input type='date' onChange={(e) => onDateChange('dateStart', e.target.value)} min={currentDate} />
              </Form.Item>
            </Col>
            <Col xs={24} sm={12} md={12} lg={8}>
              <Form.Item
                label='Data Sfarsit Proiect'
                name='dateEnd'
                rules={[
                  {
                    required: true,
                    message: 'Introduceti data sfarsit proiect!',
                  },
                ]}
              >
                <Input type='date' onChange={(e) => onDateChange('dateEnd', e.target.value)} min={currentDate} />
              </Form.Item>
            </Col>
          </>
        )}
      </Row>
      <Divider />
      <Form.List name='pmOfferIntervals'>
        {(fields, { add, remove }) => (
          <>
            {fields.map(({ key, name, ...restField }, index) => (
              <Row key={key} gutter={16} align='middle'>
                <Col xs={24} sm={12}>
                  <Form.Item
                    {...restField}
                    label='Data'
                    name={[name, 'date']}
                    rules={[{ required: true, message: 'Introduceti data!' }]}
                  >
                    <Input
                      type='date'
                      onChange={(e) => {
                        const dateValue = e.target.value;
                        dispatch(updatePmOfferInterval({ index, updates: { date: dateValue } }));
                      }}
                    />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={12}>
                  <Form.Item
                    {...restField}
                    label='Valoare'
                    name={[name, 'price']}
                    rules={[
                      { required: true, message: 'Introduceti pretul!' },
                      () => ({
                        validator(_, _value) {
                          const currentPrice = getCurrentIntervalPrice();
                          if (currentPrice <= initialValues.totalOfferValue) {
                            return Promise.resolve();
                          }
                          return Promise.reject(
                            new Error(`Valoarea totală nu poate depăși ${initialValues.totalOfferValue}`)
                          );
                        },
                      }),
                    ]}
                  >
                    <Input
                      type='number'
                      min={0}
                      max={remainingValue + Number(getCurrentIntervalPrice())}
                      onChange={(e) => {
                        const priceValue = Number(e.target.value);
                        dispatch(updatePmOfferInterval({ index, updates: { price: priceValue } }));
                        const intervals = form.getFieldValue('pmOfferIntervals') || [];
                        calculateTotal(intervals);
                      }}
                    />
                  </Form.Item>
                </Col>
                <Col xs={24}>
                  <Button onClick={() => handleRemove(remove, name)}>Sterge</Button>
                </Col>
              </Row>
            ))}
            <Form.Item>
              <Button
                type='dashed'
                onClick={() => handleAddInterval(add)}
                block
                disabled={!(getCurrentIntervalPrice() <= initialValues.totalOfferValue)}
              >
                Adauga Incasare
              </Button>
            </Form.Item>
          </>
        )}
      </Form.List>
    </Form>
  );
};

export default CompanyDetailsTab;
